import {instance} from "./instance";

export const api = {
    // параметры страницы
    getJson(uriParams) {
        return instance.get(`/api/v1/captive/get_config?${uriParams}`, {timeout: 30000})
    },
    // список фраз с переводами
    getI18n() {
        return instance.get(`/api/v1/captive/i18n/get`)
    },
    getGate() { // получить номер телефона для дозвона <call499>
        return instance.get(`/api/v1/captive/call/get_gate`)
    },
    getOtpSMS(phone) { // запрос одноразового пароля
        return instance.get(`/api/v1/captive/sms/${phone}`)
    },
    getOtpChallenger(phone,otp) { // проверка одноразового пароля из смс
        return instance.get(`/api/v1/captive/sms/${phone}/otp/${otp}`)
    },
    getPinCheck(pin) { // активация пинкода
        return instance.get(`/api/v1/captive/pin/${pin}`)
    },
    checkPushStatus(authReqId) { // проверка статуса доставки push 
        return instance.get(`/api/v1/captive/push/${authReqId}/check`)
    },
    getGate800(phone) { // резервирование с привязкой номера клиента
        return instance.get(`/api/v1/captive/call/queue/${phone}/add`)
    },
    getCheckCallAuth() { // используется для проверки дозвонился абонент или нет. Запускается в фоне раз в интервал.
        // ответы: success / not_ready
        return instance.get(`/api/v1/captive/call/check`)
    },
    getCheckAuth() { // используется для проверки создалось ли устройство для пользователя. Запускается в фоне раз в интервал.
        // ответы: success / not_ready
        return instance.get(`/api/v1/captive/auth/check`)
    },
    getPush(phone) { // запрос авторизации по push. может вернуть ошибку отправки, нужно показать поле ввода OTP код ответа в этом случае 502
        return instance.get(`/api/v1/captive/push/${phone}/add`)
    },
    // getCheckPushAuth = getCheckCallAuth
    getCreds() { // возвращает логин и пароль для активации досупа на роутере <Кнопка Войти в Интернет>
        return instance.get(`/api/v1/captive/auth`)
    },
    getTemplateUID() {
        return instance.get(`/test`)
    },
    // запрос дозвона с сообщением кода
    getVoipGate(phone) {
        return instance.get(`/api/v1/captive/call/voip/${phone}`)
    },
    // повторный запрос дозвона
    getVoipGateRetry(phone) {
        return instance.get(`/api/v1/captive/call/voip/${phone}/retry`)
    }, 
    // отправить тотже код по смс
    getVoipChallengeToSms(phone) {
        return instance.get(`/api/v1/captive/call/voip/${phone}/sms`)
    },
    // проверить код после звонка или смс
    checkOtpCall(phone, otp) {
        return instance.get(`/api/v1/captive/call/voip/${phone}/otp/${otp}`)
    },
    // получить ссылку для логина на хотспот
    getLoginRef(request) {
        return instance.post(`/api/v1/captive/auth`, request)
    },
    // слои рекламы - баннеров и опросов
    getLayers() {
        return instance.get(`/api/v1/layers`)
    },
    // проголосовать
    votePolls(poll_id, option_id) {
        return instance.get(`/api/v1/polls/vote/${poll_id}/${option_id}`)
    },
    // сообщить о событии по клику на баннере
    promoEvent(promo_id, event_name) {
        return instance.get(`/api/v1/banner/event/${promo_id}?event=${event_name}`)
    },
    // список активных file_share
    shareList() {
        return instance.get(`/api/v1/file_share/active`)
    },
    getShareFile(fileId) {
        return instance.get(`/api/v1/file_share/id/${fileId}`)
    },
    getExternalAuthMeta() {
        return instance.get(`/api/v1/captive/external`)
    },
    sendExternalAuthCreds(id, data) {
        return instance.post(`/api/v1/captive/external/${id}`, data)
    },
}